
var TECL_TenderUserInformation = {

  // Initialise the page
  Initialise: function () {
    TECL_TenderGeneral.HidePleaseWaitDlg();

    window.scrollTo(0, 0);

    TECL_TenderGeneral.InitialiseStickySidebar();
  },

  // Validate the login info and try and authenticate the details
  LogInUser: function () {
    if (TECL_Master.AddLock("TECL_TenderUserInformation.LogInUser")) {
      TECL_TenderUserInformation.ClearValidationErrors();

      var emailAddress = $("#loginEmailAddressVal").val();
      var password = $("#loginPasswordVal").val();

      var noErrors = true;

      if (!emailAddress || !TECL_Master.IsEmailAddress(emailAddress)) {
        $("#errLoginEmailAddress").removeClass("hidden");
        noErrors = false;
      }

      if (!password) {
        $("#errLoginPassword").removeClass("hidden");
        noErrors = false;
      }

      if (noErrors) {
        var cacheId = $("#cacheId").val();

        $.ajax({
          url: baseSiteUrl + "umbraco/Surface/Tender/AuthenticateUserWithOrgCheck",
          type: "POST",
          dataType: "json",
          data: {
            cacheId: cacheId,
            emailAddress: emailAddress,
            password: password
          },
          error: function () {
            TECL_Master.ClearLock("TECL_TenderUserInformation.LogInUser");
          },
          success: function (viewModel) {

            TECL_Master.ClearLock("TECL_TenderUserInformation.LogInUser");

            if (viewModel) {

              switch (viewModel.ErrorCode) {
                case 0:
                  {
                    // If the tender org Id differs from the account's Org Id
                    // We warn the user and await confirmation
                    if (viewModel.OrgChangedAccountKey != null && viewModel.OrgChangedAccountKey.length > 0) {

                      TECL_TenderUserInformation.WarnUserTenderOrgChange(viewModel.OrgChangedAccountKey);
                    } else {

                      // Reload the view so the correct controls are displayed
                      TECL_TenderUserInformation.ReloadUserInformationView();
                    }
                    break;
                  }
                case 4:
                  {
                    // Supplier account logged in
                    $("#suppLoggedInFail").removeClass("hidden");
                    break;
                  }
                default:
                  {
                    $("#errLoginFail").removeClass("hidden");
                    break;
                  }
              }
            } else {

              $("#errLoginFail").removeClass("hidden");
            }
          }
        });
      } else {
        TECL_Master.ClearLock("TECL_TenderUserInformation.LogInUser");
      }
    }
  },

  /*
   * Method used to warn the user the tender org differ's from their account org
   * If they confirm the change, the org is changed and they are signed in
   */
  WarnUserTenderOrgChange: function (webAccountOrgCacheKeyId) {

    var cacheId = $("#cacheId").val();
    var $modal = $("#accountOrgChangingDlg");

    // Setup the confirm button
    $modal.find(".btn-ok").off("click").on("click", function () {

      if (TECL_Master.AddLock("TECL_TenderUserInformation.WarnUserTenderOrgChange")) {
        $.ajax({
          url: baseSiteUrl + "umbraco/Surface/Tender/ConfirmAccountOrgChangeFromTender",
          type: "POST",
          dataType: "json",
          data: {
            cacheId: cacheId,
            orgChangedKey: webAccountOrgCacheKeyId
          },
          error: function () {
            TECL_Master.ClearLock("TECL_TenderUserInformation.WarnUserTenderOrgChange");
            $modal.modal("hide");
          },
          success: function (viewModel) {
            TECL_Master.ClearLock("TECL_TenderUserInformation.WarnUserTenderOrgChange");
            if (viewModel && viewModel.ErrorCode === 0) {

              // Confirm account org change
              $modal.modal("hide");

              // Reload the view so the correct controls are displayed
              TECL_TenderUserInformation.ReloadUserInformationView();
            } else {
              $("#errLoginFail").removeClass("hidden");
            }
          }
        });
      }
    });

    $modal.modal("show");
  },

  // Clear all validation error text
  ClearValidationErrors: function () {
    $("#errUserDetailsOrganisationNoSearchEntries").addClass("hidden");
    $("#errUserDetailsFirstName").addClass("hidden");
    $("#errUserDetailsLastName").addClass("hidden");
    $("#errUserDetailsOrganisation").addClass("hidden");
    $("#errUserDetailsPosition").addClass("hidden");
    $("#errUserDetailsEmailAddress").addClass("hidden");
    $("#errUserDetailsUsedEmailAddress").addClass("hidden");
    $("#errUserDetailsConfirmEmailAddress").addClass("hidden");
    $("#errUserDetailsPassword").addClass("hidden");
    $("#errUserDetailsConfirmPassword").addClass("hidden");
    $("#errLoginEmailAddress").addClass("hidden");
    $("#errLoginPassword").addClass("hidden");
    $("#errLoginFail").addClass("hidden");
    $("#acceptTandCsErr").addClass("hidden");
  },

  // Validate the user info section
  ValidateUserInfo: function () {
    TECL_TenderUserInformation.ClearValidationErrors();

    var $passwordField = $("#userPasswordVal");
    var webAccountId = $("#userWebAccountIdVal").val();
    var webAccountEmailAddress = $("#userWebAccountEmailAddressVal").val();
    var firstName = $("#userFirstNameVal").val();
    var lastName = $("#userLastNameVal").val();
    var positionId = $("#ddlPositions").val();
    var emailAddress = $("#userEmailAddressVal").val();
    var confirmEmailAddress = $("#userConfirmEmailAddressVal").val();
    var tandcChecked = $("#acceptTandCs").is(":checked");

    var noErrors = true;

    if (!firstName) {
      $("#errUserDetailsFirstName").removeClass("hidden");
      noErrors = false;
    }

    if (!lastName) {
      $("#errUserDetailsLastName").removeClass("hidden");
      noErrors = false;
    }

    if (!positionId) {
      $("#errUserDetailsPosition").removeClass("hidden");
      noErrors = false;
    }
    if (!emailAddress || !TECL_Master.IsEmailAddress(emailAddress)) {
      $("#errUserDetailsEmailAddress").removeClass("hidden");
      noErrors = false;

    } else if ((!webAccountEmailAddress || webAccountEmailAddress === "" || webAccountEmailAddress !== emailAddress) &&
      TECL_TenderUserInformation.ValidateEmailAddressAlreadyExists(webAccountId, emailAddress)) {
      $("#errUserDetailsUsedEmailAddress").removeClass("hidden");
      noErrors = false;

    } else if (emailAddress !== confirmEmailAddress) {
      $("#errUserDetailsConfirmEmailAddress").removeClass("hidden");
      noErrors = false;
    }

    if ($passwordField && $passwordField.length > 0) {
      var password = $passwordField.val();

      if (!password || password.length < 5) {
        $("#errUserDetailsPassword").removeClass("hidden");
        noErrors = false;
      }
    }

    if (!tandcChecked) {
      $("#acceptTandCsErr").removeClass("hidden");
      noErrors = false;
    }

    if (!noErrors) {
      $("html, body").animate({
        scrollTop: ($(".field-validation-error:visible").first().offset().top - 100)
      }, 500);
    }

    return noErrors;
  },

  // Validate that the email address isn't already being used
  ValidateEmailAddressAlreadyExists: function (webAccountId, newEmailAddress) {

    var emailAddressAlreadyExists = false;
    if (TECL_Master.AddLock("TECL_TenderUserInformation.ValidateEmailAddressAlreadyExists")) {

      // Call Server to save the tender
      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/Tender/ValidateEmailAddressAlreadyExists",
        type: "POST",
        dataType: "json",
        async: false,
        data: {
          webAccountId: webAccountId,
          newEmailAddress: newEmailAddress
        },
        error: function (exc) {
          TECL_Master.ClearLock("TECL_TenderUserInformation.ValidateEmailAddressAlreadyExists");
        },
        success: function (viewModel) {
          TECL_Master.ClearLock("TECL_TenderUserInformation.ValidateEmailAddressAlreadyExists");
          emailAddressAlreadyExists = viewModel;
        }
      });
    }
    return emailAddressAlreadyExists;
  },

  // Continue to the next stage
  SaveTender: function () {

    if (TECL_Master.AddLock("TECL_TenderUserInformation.SaveTender")) {

      if (TECL_TenderUserInformation.ValidateUserInfo()) {
        var cacheId = $("#cacheId").val();

        TECL_TenderGeneral.DisplayPleaseWaitDlg();

        var userInfoData = TECL_TenderUserInformation.SerialisedData();

        // Call Server to save the tender
        $.ajax({
          url: baseSiteUrl + "umbraco/Surface/Tender/SaveTender",
          type: "POST",
          dataType: "json",
          data: {
            cacheId: cacheId,
            userInfoData: userInfoData
          },
          error: function (exc) {
            TECL_TenderGeneral.HidePleaseWaitDlg();
            TECL_Master.ClearLock("TECL_TenderUserInformation.SaveTender");
            TECL_Master.ShowErrorDialog();
          },
          success: function (viewModel) {
            TECL_Master.ClearLock("TECL_TenderUserInformation.SaveTender");
            TECL_TenderGeneral.HidePleaseWaitDlg();

            if (viewModel.ErrorCode === 0) {
              TECL_TenderUserInformation.ContinueToNextStage();
            } else {
              TECL_Master.ShowErrorDialog(viewModel.ErrorMessage);
            }
          }
        });
      } else {
        TECL_Master.ClearLock("TECL_TenderUserInformation.SaveTender");
      }
    }
  },

  // Continue to the next stage
  ContinueToNextStage: function () {
    if (TECL_Master.AddLock("ContinueToNextStage")) {
      var cacheId = $("#cacheId").val();

      // Call Server to save the tender
      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/Tender/ContinueNextStageCompletionPage",
        type: "POST",
        data: {
          cacheId: cacheId
        },
        error: function (exc) {
          TECL_Master.ClearLock("ContinueToNextStage");
        },
        success: function (partialViewHtml) {
          TECL_Master.ClearLock("ContinueToNextStage");

          if (partialViewHtml) {
            $("#tenderPage").html(partialViewHtml);
          }
        }
      });
    }
  },

  // Get the Serialised Data
  SerialisedData: function () {
    //get standard data
    var webAccountId = $("#userWebAccountIdVal").val();
    var firstName = $("#userFirstNameVal").val();
    var lastName = $("#userLastNameVal").val();
    var positionId = $("#ddlPositions").val();
    var emailAddress = $("#userEmailAddressVal").val();
    var password = $("#userPasswordVal").val();
    var organisationName = $("#schoolSearch").val();

    var userInfoData = {
      WebAccountId: webAccountId,
      FirstName: firstName,
      LastName: lastName,
      OrganisationName: organisationName,
      PositionId: positionId,
      EmailAddress: emailAddress,
      Password: password
    }
    return userInfoData;
  },

  // Reload the user information view
  ReloadUserInformationView: function () {

    if (TECL_Master.AddLock("ReloadUserInformationView")) {
      var cacheId = $("#cacheId").val();

      // Call Server to add the product request to the cache and reload the product request list
      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/Tender/ReloadUserInformationView",
        type: "POST",
        data: {
          cacheId: cacheId
        },
        error: function (exc) {
          TECL_Master.ClearLock("ReloadUserInformationView");
        },
        success: function (partialViewHtml) {
          TECL_Master.ClearLock("ReloadUserInformationView");
          if (partialViewHtml) {
            $("#tenderPage").html(partialViewHtml);

            var webAccountId = $("#userWebAccountIdVal").val();

            if (webAccountId && webAccountId.length > 0) {
              $("html, body").animate({
                scrollTop: ($(".userInformationContinueBtn:visible").offset().top - 100)
              }, 500);
            }
          }
        }
      });
    }
  }

};